import { Transition } from '@headlessui/react';
import React, { useState, useEffect } from 'react';

const AwardsHeader = ({ title, breadcrumbs }) => {
    return (
        <>
            <div className="md:pt-36 pt-28">
                <div className="container">
                    <div className="flex items-center">
                        <i className="inline-block w-2.5 min-w-[0.66rem] h-2.5 mr-3 border-2 rounded-10 border-purple  "></i>
                        <span className="font-medium label">Awards</span>
                    </div>
                    {title && (
                        <h1 className="mt-5 mb-6 lg:mb-24 md:mt-8 h1 wow fadeInUp">
                            {title}
                        </h1>
                    )}
                </div>
            </div>
        </>
    );
};

export default AwardsHeader;
